<template>
    <div>
        <rkm-data-table
            :disabled-button-search="true"
            :fields="fields"
            :filter="localFilter"
            :repository="repositories.formularioRaas"
            :request-params="requestParams"
            :reset-table="resetTable"
            :search-by="localSearchOption"
            :search-table="searchTable"
            :tbody-tr-class="rowClass"
            ref="DataTable"
            sort-by="data"
        >
            <template v-slot:filters>
                <rkm-form-input
                    placeholder="Digite para buscar"
                    v-model="localFieldFilter"
                    @keyup.native.enter="handleEnterKey"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-form-select
                            :options="searchOptions"
                            class="m-0"
                            v-model="localSearchOption"
                        />
                    </rkm-input-group-prepend>

                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                v-model="exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos"
                            >
                                Exibir procedimentos que exigem números de autorização não preenchidos.
                            </rkm-form-checkbox>
                        </rkm-input-group-text>

                        <rkm-button
                            :disabled="localFieldFilter || !disabledButtonSearch ? false : true"
                            @click="search"
                            color="primary"
                            class="btn-search"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!localFieldFilter"
                            @click="clear"
                            class="btn-clear"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input>
            </template>

            <template v-slot:cell(pacienteNome)="{ index, item }">
                <template v-if="item.pacienteNome">
                    <rkm-button
                        :id="uniqueId(`paciente-icon-${index}`)"
                        class="mr-2"
                        small
                    >
                        <rkm-icon icon="user" />
                    </rkm-button>

                    <rkm-popover
                        :target="uniqueId(`paciente-icon-${index}`)"
                        placement="top"
                        title="Dados cadastrais"
                        triggers="hover"
                    >
                        <div>
                            <span>
                                <strong>Data de nascimento:</strong> {{ item.pacienteDataNascimento }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>Nome da mãe:</strong> {{ item.pacienteNomeMae }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CPF:</strong> {{ item.pacienteCpf }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CNS:</strong> {{ item.pacienteCns }}
                            </span>
                        </div>
                    </rkm-popover>

                    <template>
                        {{ item.pacienteNome }}

                        <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                            <strong>
                                ({{ item.pacienteNomeSocial }})
                            </strong>
                        </template>
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.Modal.open(item.id)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    Linhas em <span class="danger">vermelho</span> representam procedimentos que exigem número de autorização e que não estão preenchidos.
                </p>
            </rkm-col>
        </rkm-row>

        <Modal ref="Modal" />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import { repository } from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { Modal },
    computed: {
        requestParams() {
            return {
                exibir_procedimentos_que_exigem_numero_de_autorizacao_nao_preenchidos: this.exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos
            }
        },
        searchOptions() {
            return this.fields.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    created() {
        this.repositories = {
            formularioRaas: this.getConectaSusRepository('ambulatorio.formularioRaas')
        }
    },
    data: () => ({
        fields: [
            { key: 'data', name: 'data', label: 'Data', class: 'col-min', searchable: true, sortable: true },
            { key: 'pacienteNome', name: 'pacienteCidadao.nome', label: 'Paciente', searchable: true, sortable: true },
            { key: 'pacienteProntuario', name: 'paciente.prontuario', label: 'Prontuário', searchable: true, sortable: true, class: 'col-min' },
            { key: 'usuarioNome', name: 'usuarioCidadao.nome', label: 'Profissional', searchable: true, sortable: true },
            { key: 'especialidadeNome', name: 'especialidade.nome', label: 'Especialidade', searchable: true, sortable: true },
            { key: 'horarioChegada', name: 'horarioChegada', label: 'Horário de chegada', sortable: true, class: 'col-min' },
            { key: 'horarioAgendado', name: 'agendamento.horario', label: 'Horário agendado', sortable: true, class: 'col-min' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
        enums: { preferenciaNome },
        exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos: false,
        disabledButtonSearch: false,
        localFieldFilter: null,
        localFilter: null,
        localSearchOption: null,
        resetTable: false,
        searchTable: false,
    }),
    methods: {
        search() {
            this.searchTable = true
            this.resetTable = false
            this.localFilter = this.localFieldFilter
            this.$refs.DataTable.refresh();
        },
        clear() {
            this.localSearchOption = this.searchBy || this.searchOptions[0].value;
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos = false
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.resetTable = true
            this.searchTable = false
        },
        handleEnterKey(event) {
            if (event.key === 'Enter' && (this.localFieldFilter || !this.disabledButtonSearch)) {
                this.search();
            }
        },
        rowClass(item, type) {
            if(item && type === 'row') {
                if (item.temProcedimentoQueExigeNumeroAutorizacaoSemPreenchimento) {
                    return 'table-danger'
                }
            }
        },
    },
    mixins: [repository],
    mounted() {
        if (this.searchOptions.length > 0) {
            this.localSearchOption = this.searchOptions[0].value
        }
    },
    watch: {
        exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos: function () {
            this.clearTable()
        },
        filter(value) {
            this.localFilter = value
        },
        'localSearchOption': function () {
            this.clearSearchOption()
        },
        'localFieldFilter': function (value) {
            this.searchTable = value ? true : false
            this.clearTable()
        },
    },
}
</script>

<style scoped>
.danger {
    color: var(--danger);
}
</style>